import { useQuery } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'
import { useBuildQueryParams } from '../../../lib/hooks/useBuildQueryParams'

export default function useGetCreativeVendors({
  filters,
}: {
  filters: Record<string, unknown>
}) {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery(
    ['dealership', dealership?.id, 'utils', 'creative-vendors'],
    () =>
      request<Array<{ id: number; vendor: string }>>({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/utils/creative-vendors`,
        method: 'GET',
        params: {
          ...queryParams,
        },
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  )
}
